import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { AUTH_API_URL } from "../config";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Récupérer le token depuis l'URL
  const token = new URLSearchParams(location.search).get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (newPassword !== confirmPassword) {
      setMessage(t('reset.no_match'));
      return;
    }

    if (newPassword.length < 6) {
      setMessage(t('reset.too_short'));
      return;
    }

    try {
      await axios.post(`${AUTH_API_URL}/reset-password`, {
        token,
        newPassword,
      });
      setIsSuccess(true);
      setMessage(t('reset.success'));
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      setMessage(error.response?.data?.error || t('reset.error'));
    }
  };

  if (!token) {
    return (
      <div className="auth-container">
        <p className="error-message">{t('reset.invalid_link')}</p>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <h2>{t('reset.title')}</h2>
      {!isSuccess ? (
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder={t('reset.new_password')}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder={t('reset.confirm_new_password')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit">{t('reset.btn')}</button>
        </form>
      ) : (
        <div className="success-message">
          <p>{message}</p>
          <p>{t('reset.redirect')}</p>
        </div>
      )}
      {message && !isSuccess && <p className="error-message">{message}</p>}
    </div>
  );
};

export default ResetPassword; 
